const React = require('react')
const PropTypes = require('prop-types')
const getActiveImage = require('module/user/helpers/get_active_image')
const getDisplayImage = require('module/user/helpers/get_display_image')
const getFallbackImage = require('module/user/helpers/get_fallback_image')
const { getCloudflareUrl } = require('@aboutdotme/image-helpers')
const Raven = require('lib/raven')
const config = require('lib/config')

class MediumImage extends React.Component {
    getStyle() {
        const { user } = this.props

        let url

        const has_image = getActiveImage(user)
        const image = getDisplayImage(user)
        const fallback = getFallbackImage()

        const aspect = 3 / 2
        const width = 620
        const height = width / aspect

        if (has_image) {
            try {
                // get imgix URL
                url = getCloudflareUrl(image, {
                    width,
                    height,
                    quality: 40,
                    devicePixelRatio: 2,
                    image_domain: config.get('pumpkinhead.globals.aws_images'),
                })
            } catch (e) {
                Raven.captureException(e, {
                    extra: {
                        user_name: user.user_name,
                        image,
                    },
                })
                url = fallback.url
            }
        } else {
            url = fallback.url
        }

        const style = {
            backgroundImage: `url(${url})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center center',
            backgroundRepeat: 'no-repeat',
            paddingBottom: `${100 / aspect}%`,
        }

        return style
    }

    render() {
        const style = this.getStyle()

        return <div className="image" style={style} />
    }
}

MediumImage.propTypes = {
    user: PropTypes.shape({
        images: PropTypes.array,
        user_name: PropTypes.string,
    }).isRequired,
}

MediumImage.contextTypes = {
    globals: PropTypes.object.isRequired,
}

module.exports = MediumImage
